import React, { Fragment, useState } from "react";
import { Modal } from "./index";

const TeamSection = ({ data, teamMembers }) => {
  const [showModal, setShowModal] = useState(false);
  const [member, setMember] = useState();

  const handleShowModal = (member) => {
    setShowModal(!showModal);
    setMember(member);
  };

  return (
    <Fragment>
      {teamMembers
        ? teamMembers.map((section, index) => {
          return (
            <section className="pq-team" key={index}>
              <h6>{section.name}</h6>
              <div className="pq-team-grid">
                {section.teamMembers.nodes
                  ? section.teamMembers.nodes
                    .sort((a, b) => a.menuOrder - b.menuOrder)
                    .map((member, i) => {
                      if (member.title) {
                        return (
                          <div className="grid-item" key={`member-${i}`}>
                            {member && (
                              <>
                                <a
                                  onClick={() => handleShowModal(member)}
                                >
                                  {member.featuredImage.node && (
                                    <img
                                      alt={member.featuredImage.node.title}
                                      src={member.featuredImage.node.sourceUrl}
                                    />
                                  )}
                                </a>
                                <p className="name">{member.title}</p>
                                <p className="title">
                                  {member.teamMember.jobTitle}
                                </p>
                              </>
                            )}
                          </div>
                        );
                      } else {
                        return null;
                      }
                    })
                  : null}
              </div>
              <Modal showModal={showModal} hide={handleShowModal} member={member} />
            </section>
          );
        })
        : null}
    </Fragment>
  );
};

export default TeamSection;
